import axios from "axios";
import type { ApiRequestOptions, User } from "@/types/app";

const SCRIPT_BASE_URL = import.meta.env.VITE_FILE_SCRIPT_URL;
const backend_URL = import.meta.env.VITE_BACKEND_URL;
const api = `${backend_URL}/svnbd/data/member/get`;

export const getDataFc = async (fcno: string) => {
  const res = await axios.get(`${api}/fc_no/${fcno}`);
  return res.data.data;
};

export const getDataName = async (name: string) => {
  const res = await axios.get(`${api}/name/${name}`);
  return res.data.data;
};

export const getDocsByUserId = async (userId: string | number) => {
  const res = await axios.get(`${backend_URL}/files/get/docs/${userId}`);
  return res.data.data;
};

export const totalFC = async (
  _user?: User | null,
  { signal }: ApiRequestOptions = {},
) => {
  const res = await axios.get(`${backend_URL}/svnbd/data/istavrity/count`, {
    signal,
  });
  return res.data.count;
};

const retryRequest = async <T,>(
  fn: () => Promise<T>,
  retries = 3,
  delay = 2000,
): Promise<T> => {
  try {
    return await fn();
  } catch (err) {
    if (retries > 0 && axios.isAxiosError(err) && err.response?.status === 429) {
      await new Promise((r) => setTimeout(r, delay));
      return retryRequest(fn, retries - 1, delay * 2); // exponential backoff
    }
    throw err;
  }
};

export const uploadDocument = async ({ userId, file, docType }: { userId: string | number; file: File; docType: string }) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    reader.onload = async () => {
      const result = reader.result;
      if (typeof result !== "string") {
        reject(new Error("Failed to read the selected file as a data URL."));
        return;
      }
      const base64 = result.split(",")[1];
      try {
        const endpoint =
          docType === "adhaar"
            ? `${backend_URL}/files/upload/adhaar`
            : `${backend_URL}/files/upload/pan`;

        const res = await retryRequest(() =>
          axios.post(endpoint, {
            userId,
            type: docType,
            fileBase64: base64,
            fileName: file.name,
            mimeType: file.type,
          }),
        );

        // backend now only returns fileId, fileName
        resolve(res.data);
      } catch (err) {
        // console.log(`Error upload docs: ${err}`);
        reject(err);
      }
    };
    reader.onerror = (err) => reject(err);
  });
};

export const downloadDocument = (fileId: string) => {
  const url = `${SCRIPT_BASE_URL}?fileId=${fileId}`;
  window.open(url, "_blank");
};

export const totalMember = async (
  user: User | null | undefined,
  { signal }: ApiRequestOptions = {},
) => {
  if (!user?.permissions?.includes("see_stats")) return null;
  try {
    const res = await axios.get(`${api}/count`, { signal });
    return res.data.data;
  } catch (err) {
    console.log(`Failed to fetch member count: ${err}`);
    return null;
  }
};
